// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__fL39H","tab":"Tabs_tab__e13Sn","active":"Tabs_active__c0WVs"};